import { createStore } from "vuex";
import notifications from "./modules/notifications";

export const store = createStore({
  state: {
    notifications: [],
    componentKey: 0,
  },

  actions: {
    notifications,
    componentKey({ state }) {
      state.componentKey++;
    },
  },

  getters: {
    notifications(state) {
      return state.notifications;
    },
    componentKey(state) {
      return state.componentKey;
    },
  },
});
